import { LocalDate } from '@js-joda/core';
import { useMemo } from 'react';

import { ChronicDisease } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { createTranslatedText, dateFormatter, TranslatedText } from '@dreryk/react-common';
import { LinkSize, SidePanelListItem } from '@dreryk/react-components';

import { ChronicDiseaseDetailsModalOpener, MedicalInformationModalOpenLink } from '~legacy.patient';

import { HistoricalVisitsListItemHeader } from '../../historicalVisits/HistoricalVisitsListItemHeader';

import { ChronicDiseaseCategoryContent } from './ChronicDiseaseCategoryContent';

const EMPTY_VALUE = '-';

const formattedDate = (
   diagnosisCreationDate: LocalDate | undefined,
   diagnosisRemovalDate?: LocalDate
): TranslatedText => {
   if (!diagnosisCreationDate) {
      return createTranslatedText(EMPTY_VALUE);
   }

   if (diagnosisRemovalDate) {
      return createTranslatedText(`${dateFormatter(diagnosisCreationDate)} - ${dateFormatter(diagnosisRemovalDate)}`);
   }

   return createTranslatedText(dateFormatter(diagnosisCreationDate));
};

export const useChronicDiseaseSidePanelListItems = (
   chronicDiseases: ChronicDisease[] | undefined,
   onMedicalDataAccessAuthorizationUpdate: VoidFunction
): SidePanelListItem[] | undefined => {
   return useMemo(() => {
      if (!chronicDiseases) {
         return undefined;
      }

      return chronicDiseases.map((chronicDisease) => ({
         id: chronicDisease.id,
         headerContent: (
            <HistoricalVisitsListItemHeader
               text={formattedDate(chronicDisease.diagnosisCreationDate, chronicDisease.diagnosisRemovalDate)}
               icon={
                  <ChronicDiseaseDetailsModalOpener
                     chronicDisease={chronicDisease}
                     onMedicalDataAccessAuthorizationUpdate={onMedicalDataAccessAuthorizationUpdate}
                  >
                     {({ openModal }) => (
                        <MedicalInformationModalOpenLink
                           onClick={openModal}
                           unsignedAttachmentCount={chronicDisease.unsignedAttachmentCount}
                           size={LinkSize.SMALL}
                        />
                     )}
                  </ChronicDiseaseDetailsModalOpener>
               }
            />
         ),
         content: (
            <ChronicDiseaseDetailsModalOpener chronicDisease={chronicDisease}>
               {({ openModal }) => (
                  <ChronicDiseaseCategoryContent
                     chronicDisease={chronicDisease}
                     onShowMoreAttachmentsClick={openModal}
                  />
               )}
            </ChronicDiseaseDetailsModalOpener>
         ),
      }));
   }, [chronicDiseases, onMedicalDataAccessAuthorizationUpdate]);
};
